import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const AliExpressLogo = ()=>{
    const $ = c(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsxs("g", {
            clipPath: "url(#clip0_7514_109827)",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M27.9492 18.6236V2.07227H38.1404V4.14736H30.0595V9.2363H37.3169V11.3114H30.0595V16.4991H38.7066V18.5742H27.9492V18.6236Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M49.4115 18.6245L45.9115 14.2273L42.4115 18.6245H39.9409L44.7277 12.745L39.6836 6.66797H42.463L45.9115 11.2134L49.4115 6.66797H52.1395L47.3527 12.745L51.8821 18.6245H49.4115Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M55.2802 16.8454V24.9976H53.1699V12.794C53.1699 9.68137 55.6405 6.37109 59.5008 6.37109C63.4126 6.37109 66.3464 8.74263 66.3464 12.6458C66.3464 16.4501 63.3611 19.0687 59.964 19.0687C58.317 19.0687 56.1037 18.377 55.2802 16.8454ZM64.1332 12.6458C64.1332 9.97781 62.3317 8.39678 59.1405 8.545C57.5964 8.59441 55.2287 9.68137 55.4346 13.4857C55.4861 14.7209 56.8243 17.043 59.7582 17.043C62.2802 17.043 64.1332 15.6596 64.1332 12.6458Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M68.1484 18.6244V6.66793H70.2587V7.95251C71.2881 6.81615 72.8837 6.4209 74.5823 6.4209V8.59481C74.3249 8.5454 71.8029 8.24896 70.2587 11.411V18.6739H68.1484V18.6244Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M75.1484 12.6458C75.1484 9.1873 77.722 6.37109 81.2734 6.37109C85.6999 6.37109 87.347 9.1873 87.347 12.794V13.7822H77.4646C77.619 16.0549 79.7293 17.2407 81.6852 17.1912C83.1264 17.1418 84.1043 16.7466 85.1337 15.7584L86.5234 17.1418C85.2367 18.3276 83.5896 19.1181 81.5823 19.1181C77.8249 19.0687 75.1484 16.4007 75.1484 12.6458ZM81.119 8.39679C79.1117 8.39679 77.5676 10.0766 77.4646 11.9047H85.1337C85.1337 10.126 83.7955 8.39679 81.119 8.39679Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M88.4277 16.9445L89.9719 15.6105C89.9204 15.6105 90.7439 16.401 90.8469 16.4504C91.2072 16.7469 91.5674 16.9445 92.0307 17.0433C93.3689 17.3892 95.788 17.2903 95.9939 15.5117C96.0969 14.5235 95.3248 13.9801 94.4498 13.6342C93.3174 13.239 92.0821 13.0907 90.9498 12.5967C89.663 12.0532 88.8395 11.1144 88.8395 9.73105C88.8395 6.12433 94.1924 5.53144 96.6115 7.21128C96.7145 7.3101 97.8983 8.34765 97.8468 8.34765L96.3027 9.53342C95.5307 8.64409 94.8101 8.19943 93.163 8.19943C92.3395 8.19943 91.2071 8.54528 91.0013 9.3852C90.6924 10.571 92.0821 11.0156 93.0086 11.2627C94.2439 11.5591 95.5821 11.7567 96.663 12.399C98.1557 13.2884 98.516 15.2152 97.9498 16.6974C97.3321 18.3279 95.4792 18.9702 93.8321 19.0196C91.8763 19.1184 90.1777 18.5255 88.788 17.1915C88.6851 17.1915 88.4277 16.9445 88.4277 16.9445Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M99.2891 16.9445L100.833 15.6105C100.782 15.6105 101.605 16.401 101.708 16.4504C102.068 16.7469 102.429 16.9445 102.892 17.0433C104.23 17.3892 106.649 17.2903 106.855 15.5117C106.958 14.5235 106.186 13.9801 105.311 13.6342C104.179 13.239 102.943 13.0907 101.811 12.5967C100.524 12.0532 99.7008 11.1144 99.7008 9.73105C99.7008 6.12433 105.054 5.53144 107.473 7.21128C107.576 7.3101 108.76 8.34765 108.708 8.34765L107.164 9.53342C106.392 8.64409 105.671 8.19943 104.024 8.19943C103.201 8.19943 102.068 8.54528 101.863 9.3852C101.554 10.571 102.943 11.0156 103.87 11.2627C105.105 11.5591 106.443 11.7567 107.524 12.399C109.017 13.2884 109.377 15.2152 108.811 16.6974C108.193 18.3279 106.341 18.9702 104.693 19.0196C102.738 19.1184 101.039 18.5255 99.6493 17.1915C99.5464 17.1915 99.2891 16.9445 99.2891 16.9445Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M109.325 6.66639V5.3818H108.861V5.13477H110.097V5.3818H109.633V6.66639H109.325Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M111.64 6.66639V5.48061L111.177 6.66639H111.074L110.611 5.48061V6.66639H110.354V5.13477H110.765L111.177 6.17232L111.589 5.13477H112.001V6.66639H111.64Z",
                    fill: "#E43225"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M13.6397 18.6256L12.0956 14.673H3.75735L2.21324 18.6256H0L6.69118 2.07422H9.11029L15.75 18.6256H13.6397ZM7.82353 4.44576L4.68383 12.6473H11.2206L7.82353 4.44576Z",
                    fill: "#F7971D"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M17.1406 18.6256V2.07422H19.3024V18.6256H17.1406Z",
                    fill: "#F7971D"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M22.543 18.6235V6.91406H24.7047V18.6235H22.543Z",
                    fill: "#F7971D"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M26.7652 3.11069C26.7652 3.06128 26.7652 3.06128 26.7652 3.01188C26.7652 2.96247 26.7652 2.96247 26.7652 2.91306C25.1181 2.86366 23.7799 1.57907 23.7284 -0.00195312C23.6769 -0.00195312 23.6255 -0.00195312 23.574 -0.00195312C23.5225 -0.00195312 23.471 -0.00195312 23.4196 -0.00195312C23.3681 1.57907 22.0299 2.86366 20.3828 2.91306C20.3828 2.96247 20.3828 2.96247 20.3828 3.01188C20.3828 3.06128 20.3828 3.06128 20.3828 3.11069C22.0299 3.1601 23.3681 4.44469 23.4196 6.02571C23.471 6.02571 23.5225 6.02571 23.574 6.02571C23.6255 6.02571 23.6769 6.02571 23.7284 6.02571C23.7799 4.44469 25.1181 3.1601 26.7652 3.11069Z",
                    fill: "#F7971D"
                })
            ]
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsxs("svg", {
            width: "112",
            height: "25",
            viewBox: "0 0 112 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_7514_109827",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "112",
                            height: "25",
                            fill: "white"
                        })
                    })
                })
            ]
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
export { AliExpressLogo };
